module.exports = __webpack_public_path__ + "static/media/descrip1.6fcf84f3.jpg";